import { render, staticRenderFns } from "./DragAndDropFilePicker.vue?vue&type=template&id=66a97427&scoped=true&"
import script from "./DragAndDropFilePicker.vue?vue&type=script&lang=js&"
export * from "./DragAndDropFilePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a97427",
  null
  
)

export default component.exports